import { onlineManager } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { APP_V2_APP_EVENTS } from "../lib/analytics/events";
import { logEvent } from "../lib/analytics/log";

export interface UseOnlineStatusResult {
  isOnline: boolean;
  isInitialized: boolean;
}

export function useOnlineStatus(): UseOnlineStatusResult {
  const [isOnline, setIsOnline] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const isInitiallyOnline = onlineManager.isOnline();

    setIsInitialized(true);
    setIsOnline(isInitiallyOnline);

    logEvent(APP_V2_APP_EVENTS.INITIAL_CONNECTION_STATUS_REPORTED, {
      isOnline: isInitiallyOnline,
    });

    const unsubscribe = onlineManager.subscribe(() => {
      const isCurrentlyOnline = onlineManager.isOnline();

      setIsOnline(isCurrentlyOnline);

      logEvent(APP_V2_APP_EVENTS.CONNECTION_STATUS_CHANGED, {
        isOnline: isCurrentlyOnline,
      });
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    isOnline,
    isInitialized,
  };
}
